<template>
  <div class="ex-ivu-poptip">
    <div class="ivu-poptip">
      <div class="ivu-poptip-rel" @click="doClick">
        <slot></slot>
      </div>
      <div class="ivu-poptip-popper text-error" v-show="value" :x-placement="placement">
        <div class="ivu-poptip-content">
          <div class="ivu-poptip-arrow"></div>
          <div class="ivu-poptip-inner">
            <div class="ivu-poptip-body">
              <div class="ivu-poptip-body-content">
                <div class="ivu-poptip-body-content-inner">{{ content }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Poptip',
  props: ['content', 'value', 'placement'],
  data() {
    return {}
  },
  methods: {
    doClick() {
      this.$emit('click')
    }
  }
}

</script>
<style scoped lang="less">
.ex-ivu-poptip {
  .ivu-poptip {
    display: block;

    &-rel {
      display: block;
    }

    &-popper {
      will-change: top, left;
      position: absolute;
      top: 32px;
      left: 50%;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/commons/components/login/Poptip.vue